<template>
  <div class="gonggaobody">
    <div class="articleback">
      <el-button class="parbtn" @click="backarticlelist"
        ><i class="el-icon-back"></i> 返 回</el-button
      >
    </div>
    <div class="detailtit">
      <p>{{ videval.title ? videval.title : "" }}</p>
    </div>

    <div class="detailaut">
      <div>
        <span> <i class="el-icon-collection-tag"></i> 标签: </span>
        {{ videval.label ? videval.label : "" }}
      </div>
      <div>
        <span> <i class="el-icon-date"></i> 时间: </span>
        {{ videval.update_time ? videval.update_time : "" }}
      </div>
    </div>
    <div class="detailcon">
      <div class="videoitem">
        <!--<video
          id="player-container-id"
          preload="auto"
          playsinline
          webkit-playsinline
          v-if="videval.is_rtmp != '2'"
        ></video>-->
        <iframe class="iframitem" :src="videval.video_url"></iframe>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      videval: {
        video_url:""
      },
      player: null,
    };
  },
  props: {},
  created() {},
  computed: {},
  mounted() {
    this.getval();
  },
  methods: {
    backarticlelist() {
      window.close();
    },
    getval() {
      this.videval = JSON.parse(sessionStorage.getItem("videovalue"));
     //console.log(this.videval.video_url);
      this.player = TCPlayer("player-container-id", {}); // player-container-id 为播放器容器 ID，必须与 html 中一致
      this.player.src(this.videval.video_url); // url 播放地址
      this.player.on("error", function (error) {
        // 做一些处理
        // console.log(error);
      });
    },
  },
  watch: {},
};
</script>

  
  <style lang="less" scoped>
.gonggaobody {
  width: 100%;
  height: 100%;
  background-image: url("../../../assets/images/videobg.png");
  background-size: cover;
//   background-size: 100% 100%;
  .articleback {
    position: absolute;
    right: 1vw;
    top: 1vh;
    .parbtn {
      background: #4260ff;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .detailtit {
    width: 65%;
    margin: 0 auto;
    height: 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    > p {
      width: 100%;
      word-wrap: break-word; /*强制换行*/
      // overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*隐藏后添加省略号*/
      white-space: nowrap; /*强制不换行*/
      font-weight: 500;
      font-size: 3.5vh;
      color: #000000;
      text-align: left;
    }
  }
  .detailaut {
    width: 65%;
    display: flex;
    justify-content: flex-start;

    margin: 0 auto;
    margin-bottom: 20px;
    // flex-direction: column;
    > div {
      margin-right: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #757575;
      display: flex;
    }
  }
  .detailcon {
    width: 100%;

    .videoitem {
      width: 65%;
      //   height: 75%;
      margin: 0 auto;
      #player-container-id {
        width: 100%;
        max-width: 100%;
        height: 0;
        padding-top: 56.25%;
      }
      #wrap {
        width: 80%;
        margin: 0 auto;
      }

      @media only screen and (min-device-pixel-ratio: 2),
        only screen and (-webkit-min-device-pixel-ratio: 2) {
        .tcp-logo-img {
          width: 50%;
        }
      }
    }
    .iframitem {
      width: 100%;
      height: 700px;
    }
  }
}
</style>
  
  
  